import React, { createRef, useEffect, useState } from "react";
import { CustomAutoComplete, CustomDatePicker } from "./index";
import { CloseButton } from "@mantine/core";
import { removeTravel } from "../../helpers/flights";
import { Box, styled, Typography } from "@mui/material";
import ConnectingAirportsIcon from "@mui/icons-material/ConnectingAirports";
const FlightInputContainer = styled(Box)({
  flex: 1,
  width: "100%",
  height: "55px",
  maxHeight: "55px",
  border: "1px solid #eeeeee",
  borderRadius: "5px",
  padding: "2px 5px",
  backgroundColor: "#eeeeee",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "flex-start",
  "&: hover": {
    backgroundColor: "#D2E6F1",
    color: "whitesmoke",
  },
  "&: focus": {
    backgroundColor: "#D2E6F1",
    color: "whitesmoke",
  },
  position: "relative",
});
const FlightDateInputContainer = styled(Box)({
  height: "55px",
  maxHeight: "55px",
});
const FlightInputLabel = styled(Typography)({
  color: "#000000",
  fontSize: "14px",
});
const FlightForm = ({ index, trip, setTravels, travels, travelIndex }: any) => {
  const [leavingFrom, setLeavingFrom] = useState<string>("");
  const [goingTo, setGoingTo] = useState<string>("");

  const [dates, setDates] = useState<any | null>(new Date());

  //  const [departureDate, setDepartureDate] = useState<any | null>(new Date());
  //  const [returnDate, setReturnDate] = useState<any | null>(new Date());

  const fixSlices = (param: string, val: string) => {
    const value =
      param === "leavingFrom" || param === "goingTo" ? val.split("-")[0] : "";
    console.log("====================================");
    console.log(`Select ${param}:= `, val);
    console.log("====================================");
    switch (param) {
      case "leavingFrom":
        travels[index].leavingFrom = value;
        setLeavingFrom(val);
        break;
      case "goingTo":
        travels[index].goingTo = value;
        setGoingTo(val);
        break;
      case "dates":
        if (trip === "Round-trip") {
          travels[index].departureDate = val[0];
          travels[index].returnDate = val[1];
          //  setDepartureDate(val);
        } else {
          travels[index].departureDate = val;
        }

        break;
      /*
      case "returnDate":
        travels[index].returnDate = val;

        //  setReturnDate(val);
        break;
      */
      default:
        break;
    }
  };
  const switchPoints = () => {
    const temp = leavingFrom;
    setLeavingFrom(goingTo);
    travels[index].leavingFrom = goingTo;
    setGoingTo(temp);
    travels[index].goingTo = temp;
  };

  useEffect(() => {
    const getLastTravels = travels[travelIndex];
    console.log("====================================");
    console.log("THE TRAVEL INDEX FROM FLIGHT FORM: " + travelIndex, travels);
    console.log("====================================");
    //   setLeavingFrom(goingTo);

    if (getLastTravels) {
      setLeavingFrom(getLastTravels.goingTo);
    }
  }, [travelIndex]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        margin: 0,
        padding: 0,
        minWidth: "800px",
        width: "800px",
      }}>
      <Box
        className=""
        style={{
          width: "95%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          gap: 5,
          padding: 1,
        }}>
        <FlightInputContainer
          className="flightIContainer flightAcContainer originContainer"
          sx={{
            flex: 1,
          }}>
          <FlightInputLabel variant="body1">Origin</FlightInputLabel>
          <CustomAutoComplete
            placeholder="Origin"
            label="Origin"
            onChange={(v: any) => fixSlices("leavingFrom", v)}
            options={[]}
            value={leavingFrom}
            key="origin"
          />
          <ConnectingAirportsIcon
            sx={{
              position: "absolute",
              left: "100%",
              transform: "translate(-45%)",
              width: "25px",
              height: "25px",
              color: "#000000",
              zIndex: 5,
              padding: "3px 3px",
              backgroundColor: "#ffffff",
              borderRadius: "50%",
              cursor: "pointer",
            }}
            onClick={() => switchPoints()}
          />
        </FlightInputContainer>
        <FlightInputContainer
          className="flightIContainer flightAcContainer destinationContainer"
          sx={{
            flex: 1,
          }}>
          <FlightInputLabel variant="body1">Destination</FlightInputLabel>
          <CustomAutoComplete
            placeholder="Destination"
            label="Destination"
            onChange={(v: any) => fixSlices("goingTo", v)}
            options={[]}
            value={goingTo}
            key="destination"
          />
        </FlightInputContainer>
        <FlightDateInputContainer
          className="flightIContainer flightDContainer departDateContainer"
          sx={{
            flex: trip === "Round-trip" ? 1 : 1,
          }}>
          <CustomDatePicker
            date={dates}
            onChange={(v: any) => fixSlices("dates", v)}
            label={"Dates"}
            tripType={trip}
          />
        </FlightDateInputContainer>
      </Box>
      {trip === "Multi-City" && index !== 0 ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
          }}>
          <CloseButton
            onClick={() => removeTravel(index, travels, setTravels)}
            aria-label="Close modal"
            variant="outline"
            color="red"
          />
        </Box>
      ) : null}
    </Box>
  );
};

export default FlightForm;
